var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sale.client && _vm.sale.client.phone)?_c('div',[_c('b-button',{staticClass:"m-l-10",attrs:{"variant":"success"},on:{"click":_vm.whatsapp}},[_c('i',{staticClass:"icon-whatsapp"})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }